export const DATA_TRANSFER_FIELDS = {
  title: 'dataTransfer',
  subtitle: 'dataTransferSubTitle',
  descriptionHeaderKey: 'dataTransferDescriptionHeader',
  descriptionBodyKey: 'dataTransferDescriptionBody',
  fieldDefinitions: [
    {
      type: 'select-one',
      name: 'toggleIncludeAllStandingOrders',
      options: {
        type: 'select-one',
        selectables: [
          {
            key: 'includeAllStandingOrders',
            value: 'includeAllStandingOrders',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: null,
          },
          {
            key: 'certainStandingOrders',
            value: 'certainStandingOrders',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: {
              fieldGroupId: 'certainStandingOrdersGroup',
              fieldDefinitions: [
                {
                  type: 'select-one',
                  name: 'blackOrWhiteListStandingOrders',
                  options: {
                    type: 'select-one',
                    selectables: [
                      {
                        key: 'blackListStandingOrders',
                        value: 'blackListStandingOrders',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                      {
                        key: 'whiteListStandingOrders',
                        value: 'whiteListStandingOrders',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                    ],
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
                {
                  type: 'include',
                  name: 'StandingOrdersBlacklist',
                  options: null,
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
          {
            key: 'inculdeNothingStandingOrders',
            value: 'inculdeNothingStandingOrders',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: null,
          },
        ],
        showHeader: true,
        defaultSelection: 'includeAllStandingOrders',
      },
      gridCol: 12,
      index: 99,
      required: true,
      hidden: false,
    },
    {
      type: 'checkbox',
      name: 'informCustomerStandingOrders',
      options: {
        type: 'checkbox',
        checked: false,
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
    {
      type: 'select-one',
      name: 'toggleIncludeAllDebitsPartner',
      options: {
        type: 'select-one',
        selectables: [
          {
            key: 'includeAllDebitsPartner',
            value: 'includeAllDebitsPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: null,
          },
          {
            key: 'certainDebitsPartner',
            value: 'certainDebitsPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: {
              fieldGroupId: 'certainDebitsPartnerGroup',
              fieldDefinitions: [
                {
                  type: 'select-one',
                  name: 'blackOrWhiteListDebitsPartner',
                  options: {
                    type: 'select-one',
                    selectables: [
                      {
                        key: 'blackListDebitsPartner',
                        value: 'blackListDebitsPartner',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                      {
                        key: 'whiteListDebitsPartner',
                        value: 'whiteListDebitsPartner',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                    ],
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
                {
                  type: 'include',
                  name: 'DebitsPartnerBlacklist',
                  options: null,
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
          {
            key: 'inculdeNothingDebitsPartner',
            value: 'inculdeNothingDebitsPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: null,
          },
        ],
        showHeader: true,
        defaultSelection: 'includeAllDebitsPartner',
      },
      gridCol: 12,
      index: 99,
      required: true,
      hidden: false,
    },
    {
      type: 'checkbox',
      name: 'informCustomerDebits',
      options: {
        type: 'checkbox',
        checked: false,
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
    {
      type: 'select-one',
      name: 'toggleIncludeAllDepositsPartner',
      options: {
        type: 'select-one',
        selectables: [
          {
            key: 'includeAllDepositsPartner',
            value: 'includeAllDepositsPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: null,
          },
          {
            key: 'certainDepositsPartner',
            value: 'certainDepositsPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: {
              fieldGroupId: 'certainDepositsPartnerGroup',
              fieldDefinitions: [
                {
                  type: 'select-one',
                  name: 'blackOrWhiteListDepositsPartner',
                  options: {
                    type: 'select-one',
                    selectables: [
                      {
                        key: 'blackListDepositsPartner',
                        value: 'blackListDepositsPartner',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                      {
                        key: 'whiteListDepositsPartner',
                        value: 'whiteListDepositsPartner',
                        conflicts: null,
                        type: 'radio',
                        options: null,
                        expandable: null,
                      },
                    ],
                  },
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
                {
                  type: 'include',
                  name: 'DepositsPartnerBlacklist',
                  options: null,
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
          {
            key: 'inculdeNothingDepositsPartner',
            value: 'inculdeNothingDepositsPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: null,
          },
        ],
        showHeader: true,
        defaultSelection: 'includeAllDepositsPartner',
      },
      gridCol: 12,
      index: 99,
      required: true,
      hidden: false,
    },
    {
      type: 'checkbox',
      name: 'informCustomerDeposits',
      options: {
        type: 'checkbox',
        checked: false,
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
  ],
  index: 99,
};
